export default __webpack_public_path__ + "static/media/sliderCards_noThemeSelected.0bd54ee4.svg";